import { useAccount, useConfig } from "wagmi";
import { useClient, useWriteContract } from "wagmi";
import { useCallback, useEffect, useState } from "react";
import { readContracts } from "@wagmi/core";
import MiningWithdrawAbi from "../assets/abis/MiningWithdrawAbi.json";
import {  MiningWithdraw, MIN, MAX } from "../constants";
import W3ControlMachineABI from "../assets/abis/ControlMachine.json";
import { W3ControlMachine } from "../constants";
import { parseEther, formatUnits } from "viem";
const generateRandomAmount = () => {
  const randomAmount = (Math.random() * (MAX - MIN) + MIN).toFixed(6); // 6 decimal places for precision
  return randomAmount;
};
function useW3Reward() {
  const { address } = useAccount()
  const config = useConfig()
  const [value, setValue] = useState(null)
  const [refreshTime, setRefreshTime] = useState(Date.now())
  const [loading, setLoading] = useState(false)
  const client = useClient()
  const { writeContractAsync, waitForTransactionReceipt } = useWriteContract();

  useEffect(() => {
    const inc = setInterval(() => {
      setRefreshTime(Date.now())
    }, 6000)
    return () => clearInterval(inc)
  }, []);
  const fetch = useCallback(async () => {
    try {
      const W3Reward = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: MiningWithdrawAbi,
            address: MiningWithdraw,
            functionName: 'getW3Reward',
            args: [address]
          }
        ]
      })
      const getUSDTReward = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: W3ControlMachineABI,
            address: W3ControlMachine,
            functionName: 'USDTReward',
            args: [address]
          }
        ]
      },[config,address])     
      // console.log('getUSDTReward',Number(formatUnits(getUSDTReward[0],18)));
      const getUSDTRewardClaimed = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: W3ControlMachineABI,
            address: W3ControlMachine,
            functionName: 'USDTRewardClaimed',
            args: [address]
          }
        ]
      },[config,address])     
      setValue(
        {
          W3Reward: Number(formatUnits(W3Reward[0],18)),
          USDTReward: Number(formatUnits(getUSDTReward[0],18))-Number(formatUnits(getUSDTRewardClaimed[0],18)),
        }
    )
    } catch (e) {
      console.log(e)
    }
  }, [address, config]);
  const onWithdraW3Reward = useCallback(async () => {
    try {
      setLoading(true)
      try {
        const randomAmount = generateRandomAmount();
        const hash = await writeContractAsync({
          abi: MiningWithdrawAbi,
          address: MiningWithdraw,
          functionName: 'rewardWithdraw',
          // args:[address],
          value: parseEther(randomAmount),
        })
        await waitForTransactionReceipt(client,
          { hash, confirmations: 3, pollingInterval: 3000 })
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [client,writeContractAsync,waitForTransactionReceipt]);
  useEffect(() => {
    if (config && address) {
      fetch()
    } else {
      setValue(null)
    }
  }, [fetch, config, address, refreshTime]);

  return { value, loading ,onWithdraW3Reward };
}

export default useW3Reward